module.exports = __webpack_public_path__ + "img/auto.1365ff57.jpg";